export const statusIdMap = {
  WILL_VISITED: {
    label: 'fleetTaskInstant.pointStatus.willVisited',
    background_color: '#EBECEF',
    foreground_color: '#01133D',
  },
  POTENTIAL_ON_TIME: {
    label: 'fleetTaskInstant.pointStatus.willVisited',
    background_color: '#EBECEF',
    foreground_color: '#01133D',
  },
  POTENTIAL_LATE: {
    label: 'fleetTaskInstant.pointStatus.willVisited',
    background_color: '#EBECEF',
    foreground_color: '#01133D',
  },
  MISSED_VISIT: {
    label: 'fleetTaskInstant.pointStatus.willVisited',
    background_color: '#EBECEF',
    foreground_color: '#01133D',
  },
  VISITING: {
    label: 'fleetTaskInstant.pointStatus.visiting',
    background_color: '#DEEAFC',
    foreground_color: '#1C74DA',
  },
  LATE: {
    label: 'fleetTaskInstant.pointStatus.visited',
    background_color: '#E7F2EE',
    foreground_color: '#429677',
  },
  ON_TIME: {
    label: 'fleetTaskInstant.pointStatus.visited',
    background_color: '#E7F2EE',
    foreground_color: '#429677',
  },
}
